export default {
  props: ['id'],
  data() {
    return {
      need_pay_status_bonuses: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    results() {
      return this.$store.state.courses.testResultsList;
    },
    test() {
      return this.$store.state.courses.test;
    },
  },
  methods: {
    correctPercent(correct, wrong, all) {
      return Math.round(correct / (all / 100));
    },
  },
  mounted() {
    this.$store.dispatch('courses/GetResultsList', { profile_id: this.user.profile_id, test_id: this.id })
      .then((res) => {
        if (res?.test?.need_pay_status_bonuses) {
          this.need_pay_status_bonuses = true;
        }
      });
  },
};
